export const normalizeBarValue = (value: number | null) => {
  if (value === null) return null;

  return value > 100 ? 105 : value;
};
